import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d0065c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "潜力业务量（票数/月）", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "发货潜力（元/月）", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "发货潜力（KG/月）", -1))
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = {
  key: 0,
  class: "subtitle-content"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "(至少创建一个商机才能转为潜在客户)", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "商机状态", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "潜力月均发货量", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "OPR票数", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "潜力月均销售额(元)", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "OPR金额", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "客户承诺月均发货量", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "OCR票数", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "客户承诺月均销售额（元）", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "OCR金额", -1))

import { ref, reactive, onBeforeMount, computed } from 'vue'
import { useRoute } from 'vue-router'
import { cloneDeep } from 'lodash-es'
import { message } from '@dc-platform/dc-components'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import { goBack } from '@/hooks/cosRouter'
import { customerStatusEnum } from '../dataConfig'
import { businessTypeEnum, customerTypeEnum, businessStatusEnum } from '@/views/yuntuSales/commonEnum/dataConfig'
import { listByParamCodes } from '@/api/common'
import { clueToPotential } from '@/api/yuntuSales/chanceManage'
import { salesClueDetail } from '@/api/yuntuSales/clueManage'
import { countryChannelRelevance } from '@/api/yuntuSales/operationsManage'
import { selectForNumberValidate } from '@/utils/validate'
import { paramCodesDataFilter } from '@/utils/index'
import type { Rule } from 'ant-design-vue/es/form'
import type { FormInstance } from 'ant-design-vue'
import type { ParamCodeItem } from '@/typings/common'
import type { LbuSalesCluePotentialParams } from '@/typings/api/clueManage'
import MultipleItem from '@/components/CosViewContent/multipleItem.vue'
import calc from '@/utils/calc'
import CustomerArea from '@/components/CustomerArea'


const __default__ = { name: 'DcCosLbuSalesCluePotential' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute()
const permissionPotential = {
  edit: 'lbu_clue_potential_btn',
  save: 'lbu_clue_potential_btn'
}

const queryClueId = computed(() => route.query.clueId as string)

const businessStatusEnumFilter = computed(() => {
  return businessStatusEnum.filter((item) => item.value === 0)
})
const customerStatusEnumFilter = computed(() => {
  return customerStatusEnum.map((item) => {
    if (item.value === 13) {
      item.disabled = true
    }
    return { ...item }
  })
})

const ifB2BProduct = (index: any) => {
  const item = dataForm.createOrUpdateList[index]
  const product = item.product
  if (!product) return false
  const findOne = shippingChannel.value[index].find((item) => item.paramId === product)
  return findOne?.comment?.toUpperCase().includes('B2B') === true
}

const paramCodeData = ref<{
  [key: string]: ParamCodeItem[]
}>({
  lbu_source_channel: [], // 来源渠道
  lbu_important: [], // 月潜在收入
  lbu_demand_country: [], // 目的地国家
  lbu_warehouse_city: [], // 客户归属区域
  lbu_logistics_service_provider: [], // 竞争对手
  lbu_assistance_department: [], // 协助部门
  lbu_sale_chance_type: [], // 商机类型
  lbu_shipping_channel: [],  //出货渠道
  lbu_sales_category: []
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_lbu',
    paramCodes: [
      'lbu_important',
      'lbu_source_channel',
      'lbu_demand_country',
      'lbu_warehouse_city',
      'lbu_logistics_service_provider',
      'lbu_assistance_department',
      'lbu_sale_chance_type',
      'lbu_shipping_channel',
      'lbu_sales_category'
    ]
  }).then((res) => {
    // 递归过滤业务参数状态
    res.data = paramCodesDataFilter(res.data, 0)
    paramCodeData.value = res.data
  })
}

// 获取线索详情
const getClueDetail = () => {
  salesClueDetail({
    clueId: queryClueId.value
  }).then((res) => {
    if (res.data) {
      dataForm.customerName = res.data.customerName || undefined
      dataForm.channel = res.data.channel || undefined
      dataForm.channelExplain = res.data.channelExplain || undefined
      dataForm.customerType = res.data.customerType || undefined
      dataForm.businessType = res.data.businessType || undefined
      dataForm.monthIncome = res.data.business?.monthIncome || undefined
      dataForm.business = { id: res.data.business?.id, demandInfo: res.data.business?.demandInfo || [] }
      if (!dataForm.business.demandInfo?.length) {
        handleDemandInfoAdd()
      }
      dataForm.remark = res.data.remark || undefined
      if (res.data.customerSerial) {
        dataForm.status = 11
      }
      setTimeout(() => formRef.value?.clearValidate(), 10)
    }
  })
}

const handleDemandInfoAdd = () => {
  dataForm.business?.demandInfo?.push({
    countryId: undefined,
    amount: undefined,
    potentialBusinessVolume: undefined,
    shippingChannel: undefined
  })
}

const handleDemandInfoDel = (index: number) => {
  dataForm.business?.demandInfo?.splice(index, 1)
}

onBeforeMount(() => {
  getByParamCodes()
  getClueDetail()
})
const initForm: LbuSalesCluePotentialParams.RootObject = reactive({
  status: 10,
  createOrUpdateList: [{ originCountry: '100000000000000000' }],
  business: { demandInfo: [{}] }
})
const formRef = ref<FormInstance>()
const dataForm: LbuSalesCluePotentialParams.RootObject = reactive(cloneDeep(initForm))
const formRules: Record<string, Rule[]> = {
  input: [{ required: true, message: '请输入' }],
  select: [{ required: true, message: '请选择' }],
  selectValidate: [{ required: true, validator: selectForNumberValidate, message: '请选择' }],
  mau: [{ required: true, message: '请输入OPR票数' }],
  saleChanceType: [{ required: true, message: '请选择商机类型' }],
  competitionSituation: [{ required: true, message: '请输入竞对情况' }],
  customerSituation: [{ required: true, message: '请输入客户情况' }]
}

const checkValidate = (value1: any, value2: any, message: string) => {
  if (!value1 && !value2) {
    return Promise.reject(new Error(message))
  }

  return Promise.resolve()
}

// 根据“目的地国家”的变化获取“出货渠道(云途产品)”
const shippingChannel = ref<ParamCodeItem[][]>([])
const getShippingChannel = (index: number, val: number) => {
  const params = { paramId: val }
  countryChannelRelevance(params).then((res) => {
    shippingChannel.value[index] = res.data
  })
}
const handleCountryChange = (index: number, val?: number) => {
  if (val && val !== -9) getShippingChannel(index, val)
  dataForm.createOrUpdateList[index].product = undefined
  shippingChannel.value[index] = []
}

const handleBusinessAdd = () => {
  dataForm.createOrUpdateList.push({originCountry: '100000000000000000'})
}
const handleBusinessDel = (index: number) => {
  dataForm.createOrUpdateList.splice(index, 1)
  shippingChannel.value.splice(index, 1)
}

const loading = ref(false)
const handleSubmit = async () => {
  try {
    const params = cloneDeep(dataForm)
    params.clueId = queryClueId.value
    params.createOrUpdateList.forEach((item) => {
      item.saleChanceRefId = queryClueId.value
    })
    params.business.tpr = params.business?.demandInfo?.reduce((sum: number, item: any) => {
      if (item.amount != null) {
        return calc.Add(sum, item.amount || 0)
      }
      return calc.Add(sum, 0)
    }, 0)
    params.business.totalPotential = params.business?.demandInfo?.reduce((sum: number, item: any) => {
      if (item.potentialBusinessVolume != null) {
        return calc.Add(sum, item.potentialBusinessVolume || 0)
      }
      return calc.Add(sum, 0)
    }, 0)
    params.business.demandInfo = params.business?.demandInfo?.filter((item: any) => {
      const allNull = item.countryId === null && item.amount === null && item.potentialBusinessVolume === null && item.shippingChannel === null
      return !allNull
    })
    await clueToPotential(params)
    message.success('转潜客成功')
    goBack()
  } catch (errorInfo: any) {
    loading.value = false
  }
  loading.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_CosInput = _resolveComponent("CosInput")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_ParamCodesSelect = _resolveComponent("ParamCodesSelect")!
  const _component_CosSelect = _resolveComponent("CosSelect")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_dc_layout_card = _resolveComponent("dc-layout-card")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_CosInputNumber = _resolveComponent("CosInputNumber")!
  const _component_CosTextarea = _resolveComponent("CosTextarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, {
            ref_key: "formRef",
            ref: formRef,
            model: dataForm,
            rules: formRules,
            autocomplete: "off",
            scrollToFirstError: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_dc_layout_card, {
                title: "基础信息",
                span: 6
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, {
                    label: "客户名称",
                    name: "customerName",
                    rules: formRules.input
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: dataForm.customerName,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataForm.customerName) = $event)),
                        maxlength: 100
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["rules"]),
                  _createVNode(_component_dc_form_item, {
                    label: "客户状态",
                    name: "status",
                    rules: formRules.select
                  }, {
                    label: _withCtx(() => [
                      _createTextVNode(" 客户状态 "),
                      _createVNode(_component_a_tooltip, {
                        placement: "topLeft",
                        overlayStyle: { maxWidth: '800px' }
                      }, {
                        title: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(customerStatusEnum), (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: item.value
                            }, [
                              _createElementVNode("p", null, _toDisplayString(item.label) + _toDisplayString(item.desc ? `：${item.desc}` : ''), 1)
                            ]))
                          }), 128))
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: dataForm.status,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((dataForm.status) = $event)),
                        disabled: true,
                        options: customerStatusEnumFilter.value,
                        placeholder: "请选择",
                        allowClear: ""
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }, 8, ["rules"]),
                  _createVNode(_component_dc_form_item, {
                    label: "来源渠道",
                    name: "channel",
                    rules: formRules.select,
                    class: "form-item_compact"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input_group, { compact: "" }, {
                        default: _withCtx(() => [
                          _createVNode(ParamCodeCascader, {
                            value: dataForm.channel,
                            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((dataForm.channel) = $event)),
                            options: paramCodeData.value.lbu_source_channel,
                            style: {"width":"33%"}
                          }, null, 8, ["value", "options"]),
                          _createVNode(_component_dc_form_item, {
                            name: "channelExplain",
                            span: 24,
                            style: {"width":"67%"},
                            class: "last-compact"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_CosInput, {
                                value: dataForm.channelExplain,
                                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((dataForm.channelExplain) = $event)),
                                maxlength: 100
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["rules"]),
                  _createVNode(_component_dc_form_item, {
                    label: "客户类型",
                    name: "customerType",
                    rules: formRules.select,
                    formType: "view"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: dataForm.customerType,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((dataForm.customerType) = $event)),
                        options: _unref(customerTypeEnum),
                        placeholder: "请选择",
                        allowClear: ""
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }, 8, ["rules"]),
                  _createVNode(_component_dc_form_item, {
                    label: "业务收入等级",
                    name: "monthIncome",
                    rules: formRules.selectValidate
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ParamCodesSelect, {
                        value: dataForm.monthIncome,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((dataForm.monthIncome) = $event)),
                        options: paramCodeData.value.lbu_important,
                        placeholder: "请选择",
                        allowClear: ""
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }, 8, ["rules"]),
                  _createVNode(_component_dc_form_item, {
                    label: "业务类型",
                    name: "businessType",
                    rules: formRules.select
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosSelect, {
                        value: dataForm.businessType,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((dataForm.businessType) = $event)),
                        options: _unref(businessTypeEnum),
                        placeholder: "请选择",
                        allowClear: ""
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }, 8, ["rules"]),
                  _createVNode(_component_a_col, { span: 12 }),
                  _createVNode(_component_dc_form_item, {
                    label: "备注",
                    span: 12,
                    name: "remark"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_textarea, {
                        value: dataForm.remark,
                        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((dataForm.remark) = $event)),
                        maxlength: 2000,
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_dc_layout_card, {
                title: "目的地国家",
                span: 4
              }, {
                subTitle: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    ghost: "",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (handleDemandInfoAdd()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("新增")
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(MultipleItem, { line: false }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataForm.business?.demandInfo, (item, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                          _createVNode(_component_dc_form_item, {
                            label: index ? '' : '目的地国家',
                            class: _normalizeClass(index ? 'no-form-label' : ''),
                            name: ['business', 'demandInfo', index, 'countryId'],
                            rules: {
                    message: '请选择',
                    validator: _unref(selectForNumberValidate),
                    required: true
                  }
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ParamCodesSelect, {
                                value: item.countryId,
                                "onUpdate:value": ($event: any) => ((item.countryId) = $event),
                                options: paramCodeData.value.lbu_demand_country,
                                allowClear: ""
                              }, null, 8, ["value", "onUpdate:value", "options"])
                            ]),
                            _: 2
                          }, 1032, ["label", "class", "name", "rules"]),
                          _createVNode(_component_dc_form_item, {
                            label: index ? '' : '出货渠道',
                            class: _normalizeClass(index ? 'no-form-label' : ''),
                            name: ['business', 'demandInfo', index, 'shippingChannel']
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ParamCodesSelect, {
                                value: item.shippingChannel,
                                "onUpdate:value": ($event: any) => ((item.shippingChannel) = $event),
                                options: paramCodeData.value.lbu_shipping_channel,
                                mode: "multiple"
                              }, null, 8, ["value", "onUpdate:value", "options"])
                            ]),
                            _: 2
                          }, 1032, ["label", "class", "name"]),
                          _createVNode(_component_dc_form_item, {
                            label: index ? '' : 'TPR（票数/月）',
                            class: _normalizeClass(index ? 'no-form-label' : ''),
                            name: ['business', 'demandInfo', index, 'potentialBusinessVolume']
                          }, {
                            label: _withCtx(() => [
                              _createVNode(_component_a_tooltip, {
                                placement: "topLeft",
                                overlayStyle: { maxWidth: '800px' }
                              }, {
                                title: _withCtx(() => [
                                  _hoisted_1
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, _toDisplayString(`${index ? '' : 'TPR（票数/月）'}`), 1),
                                  _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_CosInputNumber, {
                                value: item.potentialBusinessVolume,
                                "onUpdate:value": ($event: any) => ((item.potentialBusinessVolume) = $event),
                                min: 0,
                                maxlength: 15,
                                "cos-type": "money",
                                style: {"width":"100%"}
                              }, null, 8, ["value", "onUpdate:value"])
                            ]),
                            _: 2
                          }, 1032, ["label", "class", "name"]),
                          _createVNode(_component_dc_form_item, {
                            label: index ? '' : 'TPR（元/月）',
                            class: _normalizeClass(index ? 'no-form-label' : ''),
                            name: ['business', 'demandInfo', index, 'amount']
                          }, {
                            label: _withCtx(() => [
                              _createVNode(_component_a_tooltip, {
                                placement: "topLeft",
                                overlayStyle: { maxWidth: '800px' }
                              }, {
                                title: _withCtx(() => [
                                  _hoisted_2
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, _toDisplayString(`${index ? '' : 'TPR（元/月）'}`), 1),
                                  _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_CosInputNumber, {
                                value: item.amount,
                                "onUpdate:value": ($event: any) => ((item.amount) = $event),
                                min: 0,
                                maxlength: 15,
                                "cos-type": "money",
                                style: {"width":"100%"}
                              }, null, 8, ["value", "onUpdate:value"])
                            ]),
                            _: 2
                          }, 1032, ["label", "class", "name"]),
                          _createVNode(_component_dc_form_item, {
                            label: index ? '' : 'TPR（KG/月）',
                            class: _normalizeClass(index ? 'no-form-label' : ''),
                            name: ['business', 'demandInfo', index, 'tprWeight'],
                            span: 6
                          }, {
                            label: _withCtx(() => [
                              _createVNode(_component_a_tooltip, {
                                placement: "topLeft",
                                overlayStyle: { maxWidth: '800px' }
                              }, {
                                title: _withCtx(() => [
                                  _hoisted_3
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, _toDisplayString(`${index ? '' : 'TPR（KG/月）'}`), 1),
                                  _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_4, [
                                _createVNode(_component_CosInputNumber, {
                                  value: item.tprWeight,
                                  "onUpdate:value": ($event: any) => ((item.tprWeight) = $event),
                                  min: 0,
                                  maxlength: 15,
                                  "cos-type": "money",
                                  style: {"width":"100%"}
                                }, null, 8, ["value", "onUpdate:value"]),
                                (dataForm.business?.demandInfo && dataForm.business?.demandInfo.length > 1)
                                  ? (_openBlock(), _createBlock(_component_a_button, {
                                      key: 0,
                                      type: "text",
                                      danger: "",
                                      style: {"padding":"0 0 0 12px"},
                                      onClick: ($event: any) => (handleDemandInfoDel(index))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("删除 ")
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["label", "class", "name"]),
                          _createVNode(_component_a_col, { span: 24 })
                        ], 64))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataForm.createOrUpdateList, (item, index) => {
                return (_openBlock(), _createBlock(_component_dc_layout_card, {
                  key: index,
                  title: `商机${index + 1}`,
                  span: 6
                }, {
                  subTitle: _withCtx(() => [
                    (index === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _hoisted_6,
                          _createVNode(_component_a_button, {
                            type: "primary",
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (handleBusinessAdd()))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("新增")
                            ]),
                            _: 1
                          })
                        ]))
                      : (_openBlock(), _createBlock(_component_a_button, {
                          key: 1,
                          danger: "",
                          onClick: ($event: any) => (handleBusinessDel(index))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("删除")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_dc_form_item, {
                      name: ['createOrUpdateList', index, 'originCountry'],
                      label: "始发地国家",
                      rules: formRules.select
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(CustomerArea), {
                          value: item.originCountry,
                          "onUpdate:value": ($event: any) => ((item.originCountry) = $event),
                          "change-on-select": "",
                          showSearch: "",
                          "display-level": 1,
                          allowClear: ""
                        }, null, 8, ["value", "onUpdate:value"])
                      ]),
                      _: 2
                    }, 1032, ["name", "rules"]),
                    _createVNode(_component_dc_form_item, {
                      label: "目的地国家",
                      name: ['createOrUpdateList', index, 'requiredCountry'],
                      rules: formRules.selectValidate
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ParamCodesSelect, {
                          value: item.requiredCountry,
                          "onUpdate:value": ($event: any) => ((item.requiredCountry) = $event),
                          options: paramCodeData.value.lbu_demand_country,
                          placeholder: "请选择",
                          allowClear: "",
                          onChange: (val) => handleCountryChange(index, val)
                        }, null, 8, ["value", "onUpdate:value", "options", "onChange"])
                      ]),
                      _: 2
                    }, 1032, ["name", "rules"]),
                    _createVNode(_component_dc_form_item, {
                      label: "云途产品",
                      name: ['createOrUpdateList', index, 'product'],
                      rules: formRules.selectValidate
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CosSelect, {
                          value: item.product,
                          "onUpdate:value": ($event: any) => ((item.product) = $event),
                          options: shippingChannel.value[index],
                          fieldNames: { label: 'cnName', value: 'paramId' },
                          allowClear: ""
                        }, null, 8, ["value", "onUpdate:value", "options"])
                      ]),
                      _: 2
                    }, 1032, ["name", "rules"]),
                    _createVNode(_component_dc_form_item, {
                      label: "客户归属区域",
                      name: ['createOrUpdateList', index, 'warehouseAttribution'],
                      rules: formRules.select
                    }, {
                      default: _withCtx(() => [
                        _createVNode(ParamCodeCascader, {
                          value: item.warehouseAttribution,
                          "onUpdate:value": ($event: any) => ((item.warehouseAttribution) = $event),
                          options: paramCodeData.value.lbu_warehouse_city
                        }, null, 8, ["value", "onUpdate:value", "options"])
                      ]),
                      _: 2
                    }, 1032, ["name", "rules"]),
                    _createVNode(_component_dc_form_item, {
                      label: "商机状态",
                      name: ['createOrUpdateList', index, 'status'],
                      rules: formRules.select
                    }, {
                      label: _withCtx(() => [
                        _createVNode(_component_a_tooltip, {
                          placement: "topLeft",
                          overlayStyle: { maxWidth: '800px' }
                        }, {
                          title: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(businessStatusEnumFilter.value, (item) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: item.value
                              }, [
                                _createElementVNode("p", null, _toDisplayString(item.label) + _toDisplayString(item.desc ? `：${item.desc}` : ''), 1)
                              ]))
                            }), 128))
                          ]),
                          default: _withCtx(() => [
                            _hoisted_7,
                            _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          value: item.status,
                          "onUpdate:value": ($event: any) => ((item.status) = $event),
                          options: businessStatusEnumFilter.value,
                          placeholder: "请选择",
                          onchange: "",
                          allowClear: ""
                        }, null, 8, ["value", "onUpdate:value", "options"])
                      ]),
                      _: 2
                    }, 1032, ["name", "rules"]),
                    _createVNode(_component_dc_form_item, {
                      label: "商机类型",
                      name: ['createOrUpdateList', index, 'saleChanceType'],
                      rules: formRules.saleChanceType
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ParamCodesSelect, {
                          value: item.saleChanceType,
                          "onUpdate:value": ($event: any) => ((item.saleChanceType) = $event),
                          options: paramCodeData.value.lbu_sale_chance_type,
                          allowClear: ""
                        }, null, 8, ["value", "onUpdate:value", "options"])
                      ]),
                      _: 2
                    }, 1032, ["name", "rules"]),
                    _createVNode(_component_dc_form_item, {
                      label: "竞争对手",
                      name: ['createOrUpdateList', index, 'competitors'],
                      rules: formRules.select
                    }, {
                      default: _withCtx(() => [
                        _createVNode(ParamCodeCascader, {
                          value: item.competitors,
                          "onUpdate:value": ($event: any) => ((item.competitors) = $event),
                          options: paramCodeData.value.lbu_logistics_service_provider,
                          placeholder: "请选择",
                          multiple: "",
                          mode: "multiple",
                          "max-tag-count": "responsive",
                          allowClear: ""
                        }, null, 8, ["value", "onUpdate:value", "options"])
                      ]),
                      _: 2
                    }, 1032, ["name", "rules"]),
                    _createVNode(_component_dc_form_item, {
                      label: "协助部门",
                      name: ['createOrUpdateList', index, 'assistDepartment']
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ParamCodesSelect, {
                          value: item.assistDepartment,
                          "onUpdate:value": ($event: any) => ((item.assistDepartment) = $event),
                          options: paramCodeData.value.lbu_assistance_department,
                          placeholder: "请选择",
                          allowClear: ""
                        }, null, 8, ["value", "onUpdate:value", "options"])
                      ]),
                      _: 2
                    }, 1032, ["name"]),
                    _createVNode(_component_dc_form_item, {
                      label: "OPR票数",
                      name: ['createOrUpdateList', index, 'mau'],
                      rules: ifB2BProduct(index) ? undefined : formRules.mau
                    }, {
                      label: _withCtx(() => [
                        _createVNode(_component_a_tooltip, {
                          placement: "topLeft",
                          overlayStyle: { maxWidth: '800px' }
                        }, {
                          title: _withCtx(() => [
                            _hoisted_8
                          ]),
                          default: _withCtx(() => [
                            _hoisted_9,
                            _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_CosInputNumber, {
                          value: item.mau,
                          "onUpdate:value": ($event: any) => ((item.mau) = $event),
                          min: 0,
                          maxlength: 15,
                          placeholder: "请输入OPR票数",
                          oninput: "value= value.length === 1 ? value.replace(/[^1-9]/g,''):value.replace(/[^\\d]/g,'')"
                        }, null, 8, ["value", "onUpdate:value"])
                      ]),
                      _: 2
                    }, 1032, ["name", "rules"]),
                    _createVNode(_component_dc_form_item, {
                      label: "OPR金额",
                      name: ['createOrUpdateList', index, 'planSaleAmount'],
                      rules: [{ required: !ifB2BProduct(index), message: '请输入OPR金额' }]
                    }, {
                      label: _withCtx(() => [
                        _createVNode(_component_a_tooltip, {
                          placement: "topLeft",
                          overlayStyle: { maxWidth: '800px' }
                        }, {
                          title: _withCtx(() => [
                            _hoisted_10
                          ]),
                          default: _withCtx(() => [
                            _hoisted_11,
                            _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_CosInputNumber, {
                          value: item.planSaleAmount,
                          "onUpdate:value": ($event: any) => ((item.planSaleAmount) = $event),
                          min: 0,
                          maxlength: 15,
                          placeholder: "对应仓库及渠道的OPR金额",
                          oninput: "value=value.length === 1 ?value.replace(/[^1-9]/g, '') : value.replace(/[^\\d.]/g, '')"
                        }, null, 8, ["value", "onUpdate:value"])
                      ]),
                      _: 2
                    }, 1032, ["name", "rules"]),
                    _createVNode(_component_dc_form_item, {
                      label: "OCR票数",
                      name: ['createOrUpdateList', index, 'committedShipment'],
                      rules: [{ required: item.status === 4 || item.status === 9 || item.status === 5 || item.status === 7, message: '请输入OCR票数' }]
                    }, {
                      label: _withCtx(() => [
                        _createVNode(_component_a_tooltip, {
                          placement: "topLeft",
                          overlayStyle: { maxWidth: '800px' }
                        }, {
                          title: _withCtx(() => [
                            _hoisted_12
                          ]),
                          default: _withCtx(() => [
                            _hoisted_13,
                            _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_CosInputNumber, {
                          value: item.committedShipment,
                          "onUpdate:value": ($event: any) => ((item.committedShipment) = $event),
                          min: 0,
                          maxlength: 15,
                          placeholder: "请输入OCR票数",
                          oninput: "value= value.length === 1 ? value.replace(/[^1-9]/g,''):value.replace(/[^\\d]/g,'')"
                        }, null, 8, ["value", "onUpdate:value"])
                      ]),
                      _: 2
                    }, 1032, ["name", "rules"]),
                    _createVNode(_component_dc_form_item, {
                      label: "OCR金额",
                      name: ['createOrUpdateList', index, 'committedSaleAmount'],
                      rules: [{ required: item.status === 4 || item.status === 9 || item.status === 5 || item.status === 7, message: '请输入OCR金额' }]
                    }, {
                      label: _withCtx(() => [
                        _createVNode(_component_a_tooltip, {
                          placement: "topLeft",
                          overlayStyle: { maxWidth: '800px' }
                        }, {
                          title: _withCtx(() => [
                            _hoisted_14
                          ]),
                          default: _withCtx(() => [
                            _hoisted_15,
                            _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_CosInputNumber, {
                          value: item.committedSaleAmount,
                          "onUpdate:value": ($event: any) => ((item.committedSaleAmount) = $event),
                          min: 0,
                          maxlength: 15,
                          placeholder: "请输入OCR金额",
                          oninput: "value=value.length === 1 ?value.replace(/[^1-9]/g, '') : value.replace(/[^\\d.]/g, '')"
                        }, null, 8, ["value", "onUpdate:value"])
                      ]),
                      _: 2
                    }, 1032, ["name", "rules"]),
                    (ifB2BProduct(index))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_dc_form_item, {
                            label: "OPR重量（KG）",
                            name: ['createOrUpdateList', index, 'oprWeight'],
                            rules: formRules.input
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_CosInputNumber, {
                                style: {"width":"100%"},
                                min: 0,
                                maxlength: 15,
                                "cos-type": "money",
                                value: item.oprWeight,
                                "onUpdate:value": ($event: any) => ((item.oprWeight) = $event),
                                placeholder: "请输入",
                                oninput: "value=value.length === 1 ?value.replace(/[^1-9]/g, '') : value.replace(/[^\\d.]/g, '')"
                              }, null, 8, ["value", "onUpdate:value"])
                            ]),
                            _: 2
                          }, 1032, ["name", "rules"]),
                          _createVNode(_component_dc_form_item, {
                            label: "OCR重量（KG）",
                            name: ['createOrUpdateList', index, 'ocrWeight']
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_CosInputNumber, {
                                style: {"width":"100%"},
                                min: 0,
                                maxlength: 15,
                                "cos-type": "money",
                                value: item.ocrWeight,
                                "onUpdate:value": ($event: any) => ((item.ocrWeight) = $event),
                                placeholder: "请输入",
                                oninput: "value=value.length === 1 ?value.replace(/[^1-9]/g, '') : value.replace(/[^\\d.]/g, '')"
                              }, null, 8, ["value", "onUpdate:value"])
                            ]),
                            _: 2
                          }, 1032, ["name"]),
                          _createVNode(_component_dc_form_item, {
                            label: "OPR方数（m³）",
                            name: ['createOrUpdateList', index, 'oprCube']
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_CosInputNumber, {
                                style: {"width":"100%"},
                                min: 0,
                                maxlength: 15,
                                "cos-type": "money",
                                value: item.oprCube,
                                "onUpdate:value": ($event: any) => ((item.oprCube) = $event),
                                placeholder: "请输入",
                                oninput: "value=value.length === 1 ?value.replace(/[^1-9]/g, '') : value.replace(/[^\\d.]/g, '')"
                              }, null, 8, ["value", "onUpdate:value"])
                            ]),
                            _: 2
                          }, 1032, ["name"]),
                          _createVNode(_component_dc_form_item, {
                            label: "OCR方数（m³）",
                            name: ['createOrUpdateList', index, 'ocrCube']
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_CosInputNumber, {
                                style: {"width":"100%"},
                                min: 0,
                                maxlength: 15,
                                "cos-type": "money",
                                value: item.ocrCube,
                                "onUpdate:value": ($event: any) => ((item.ocrCube) = $event),
                                placeholder: "请输入",
                                oninput: "value=value.length === 1 ?value.replace(/[^1-9]/g, '') : value.replace(/[^\\d.]/g, '')"
                              }, null, 8, ["value", "onUpdate:value"])
                            ]),
                            _: 2
                          }, 1032, ["name"]),
                          _createVNode(_component_dc_form_item, {
                            label: "发货频次（次/月）",
                            name: ['createOrUpdateList', index, 'shipmentFrequency'],
                            rules: formRules.input
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_CosInputNumber, {
                                style: {"width":"100%"},
                                min: 0,
                                maxlength: 15,
                                "cos-type": "money",
                                value: item.shipmentFrequency,
                                "onUpdate:value": ($event: any) => ((item.shipmentFrequency) = $event),
                                placeholder: "请输入发货频次",
                                oninput: "value=value.length === 1 ? value.replace(/[^1-9]/g, '') : value.replace(/[^\\d.]/g, '')"
                              }, null, 8, ["value", "onUpdate:value"])
                            ]),
                            _: 2
                          }, 1032, ["name", "rules"]),
                          _createVNode(_component_dc_form_item, {
                            label: "货物类型",
                            name: ['createOrUpdateList', index, 'goodsCategory'],
                            rules: formRules.select
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ParamCodesSelect, {
                                value: item.goodsCategory,
                                "onUpdate:value": ($event: any) => ((item.goodsCategory) = $event),
                                options: paramCodeData.value.lbu_sales_category,
                                allowClear: "",
                                mode: "multiple"
                              }, null, 8, ["value", "onUpdate:value", "options"])
                            ]),
                            _: 2
                          }, 1032, ["name", "rules"])
                        ], 64))
                      : _createCommentVNode("", true),
                    _createVNode(_component_dc_form_item, {
                      label: "竞对情况",
                      span: 12,
                      name: ['createOrUpdateList', index, 'competitionSituation'],
                      rules: formRules.competitionSituation
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CosTextarea, {
                          value: item.competitionSituation,
                          "onUpdate:value": ($event: any) => ((item.competitionSituation) = $event),
                          maxlength: 2000,
                          placeholder: "描述竞争对手所释放给该客户的具体价格，账期或其他活动策略，转运时间，货量要求等"
                        }, null, 8, ["value", "onUpdate:value"])
                      ]),
                      _: 2
                    }, 1032, ["name", "rules"]),
                    _createVNode(_component_dc_form_item, {
                      label: "客户情况",
                      span: 12,
                      name: ['createOrUpdateList', index, 'customerSituation'],
                      rules: formRules.customerSituation
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CosTextarea, {
                          value: item.customerSituation,
                          "onUpdate:value": ($event: any) => ((item.customerSituation) = $event),
                          maxlength: 2000,
                          placeholder: "客户的营业模式，最近一次沟通和拜访的情况和进度，遇到的问题"
                        }, null, 8, ["value", "onUpdate:value"])
                      ]),
                      _: 2
                    }, 1032, ["name", "rules"]),
                    _createVNode(_component_dc_form_item, {
                      label: "所需支持",
                      span: 12
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CosTextarea, {
                          value: item.requiredSupport,
                          "onUpdate:value": ($event: any) => ((item.requiredSupport) = $event),
                          maxlength: 2000,
                          placeholder: "针对客户商机转换所需要的支持和帮助内容"
                        }, null, 8, ["value", "onUpdate:value"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_dc_form_item, {
                      label: "备注",
                      name: "remark",
                      span: 12
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CosTextarea, {
                          value: item.remark,
                          "onUpdate:value": ($event: any) => ((item.remark) = $event),
                          maxlength: 2000,
                          placeholder: "其他需要特殊说明的内容，客户货品重量情况等"
                        }, null, 8, ["value", "onUpdate:value"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["title"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["model"]),
          _createVNode(_component_cos_footer_button, {
            value: dataForm,
            "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((dataForm) = $event)),
            formRef: formRef.value,
            permissionPage: permissionPotential,
            resetValue: initForm,
            loading: loading.value,
            disabled: false,
            onSubmit: handleSubmit
          }, null, 8, ["value", "formRef", "resetValue", "loading"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})